import CompleteUserDetails from 'Modals/CompleteUserDetails';
import moment from 'moment'
import React, { useState } from 'react'

function CaseProfDetails({userCaseDets}) {
    const [showModal, setShowModal] = useState(false);
    const [currentUser, setCurrentUser] = useState({})
    const caseProfData = {
        "requested" : "Requested",
        "approved" : "Approved",
        "denied" : "Denied",
        "conflict": "Marked as Conflict",
        "noConflict" : "Conflict cleared",
        "reqToClose" : "Requested to close" ,
        "closed" : "Closed"
    }
  return (
    <>
    {   
        showModal &&
        <CompleteUserDetails uploadNew={showModal} user={currentUser} onClose={() => setShowModal(false)}
        />
    }
   <div className='my-4 mt-12'>
    {Object.entries(userCaseDets).map(([label, value], index) => (
        <>
            <div className='flex w-full flex-col lg:px-40'>
                <div className={(value.length === 0 ? "bg-gray-100 text-gray-600 " : "bg-green-100 text-green-600 ") + 'flex p-1 px-2 font-bold justify-between text-md mb-1 rounded w-full'}>
                    <div className='mr-1 w-[200px]'>{caseProfData[label]}</div>
                    <div>{value.length}</div>
                </div>
                {value.length !== 0 && 
                <div className={'flex flex-col border p-2 mt-2 text-sm w-full mb-2 overflow-y-scroll block '+ (parseInt(value.length) > 4 ? ' h-[200px]' : ' h-[120px]')}>
                    <div className='flex w-full text-gray-800 bg-gray-100'>
                        <div className='w-1/4 border-r-1 p-1'> Name</div>
                        <div className='w-1/2 border-r-1 p-1'> Email</div>

                        <div className='w-1/2 border-r-1 p-1'> Legal Type</div>


                        <div className='w-1/2 p-1'>Status timestamp </div>

                    </div>
                {value.map((i) => {
                        return<div className='w-full flex cursor-pointer bg-gray-50 rounded mt-1 hover:font-bold' onClick={()=>{setCurrentUser(i.userId); setShowModal(true)}}>
                        <div className='w-1/4 border-r-1 p-1'>{i?.userId?.firstName} {i?.userId?.lastName}</div>
                        <div className='w-1/2 border-r-1 p-1'>{i?.userId?.email}</div>

                        <div className='w-1/2 border-r-1 p-1'>{i?.userId?.legalType}</div>

                        <div className='w-1/2 p-1'>{moment(i?.updated_at).format("MM/DD/YYYY")}</div>

                      </div>
                })}
               
                </div>
                }
            </div>
         
        </>
    ))}
   </div>
   </>
  )
}

export default CaseProfDetails